// @react/hooks/useSecretCertificate.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { secretCertificateStore } from '@core/stores';

/**
 * React hook for Certificate operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useSecretCertificate } from '@react/hooks';
 *
 * const CertificateList = observer(() => {
 *   const store = useSecretCertificate();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useSecretCertificate() {
  return secretCertificateStore;
}
